// const BaseUrl = "http://localhost:8080";
const BaseUrl = "https://hkcl-recruitment.hkcl.net";

export default BaseUrl;